import { render, staticRenderFns } from "./ShiftsComponent.vue?vue&type=template&id=8f2f57ce&"
import script from "./ShiftsComponent.vue?vue&type=script&lang=ts&"
export * from "./ShiftsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftsComponent.vue?vue&type=style&index=0&id=8f2f57ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports